import React from "react";
import { Box, TextField } from "@mui/material";
import Label from "../../../components/Label/Label";
import { getFieldLabel } from "./encodingFunctions";

type EncodingDialogMetadataProps = {
  metadataFields: string[];
  currentData: Record<string, string | number>;
  handleChange: (input: Record<string, string | number>) => void;
}

export default function EncodingDialogMetadata({
  metadataFields,
  currentData,
  handleChange
}: EncodingDialogMetadataProps) {
  const handleMetadataChange = (field: string, value: string) => {
    handleChange({
      ...currentData,
      [field]: value
    })
  }

  return (
    <>
      {metadataFields.map((field) => <Box
        key={field}
      >
        <Label
          text={getFieldLabel(field)}
        />
        <TextField
          fullWidth
          id={`metadata_${field}`}
          name={`metadata_${field}`}
          value={currentData[field] === undefined || Number.isNaN(currentData[field]) ? "" : currentData[field]}
          onChange={({ target: { value} }) => handleMetadataChange(field, value)}
        />
      </Box>)}
    </>
  )
}